// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Expressions: (t, data?, options?) => t('enum.paragraph-style.expressions.name', data, options),
  OrderedList: (t, data?, options?) => t('enum.paragraph-style.ordered-list.name', data, options),
  Plain: (t, data?, options?) => t('enum.paragraph-style.plain.name', data, options),
  Poem: (t, data?, options?) => t('enum.paragraph-style.poem.name', data, options),
  Tip: (t, data?, options?) => t('enum.paragraph-style.tip.name', data, options),
  UnorderedList: (t, data?, options?) => t('enum.paragraph-style.unordered-list.name', data, options),
  /* eslint-enable max-len */
};
